
$(function() {
    $('button[data-email-preview-url],a[data-email-preview-url]').on('click', function() {
        const $self = $(this);

        if (!openInNewTab($self)) {
            $self.parent().find('.preview-loading-spinner').show();
        }

        if (typeof window.finaliseCropForPersonalisedGift === 'function' && $('#buttonFinaliseCrop').is(':visible')) {
            window.finaliseCropForPersonalisedGift(function () {
                getEmailPreview($self);
            });
        } else {
            getEmailPreview($self);
        }

        function getEmailPreview($self) {
            var value = $('[name="GiftCardPriceX"]').val();
            if (value === '') {
                value = '10';
            }

            const from = $('[name="From"]').val();
            const message = $('[name="Message"]').val();
            const productId = $('[name="GiftCardProductId"]').val();
            const to = $('[name="To"]').val();

            if (openInNewTab($self)) {
                var url = `${$self.data('email-preview-url')}?value=${value}&sendersName=${from}&message=${message}&design=${productId}&recipientName=${to}`;
                window.open(encodeURI(url), '_blank').focus();
            } else {
                $.ajax({
                    url: $self.data('email-preview-url'),
                    type: 'POST',
                    data: {
                        value: value,
                        sendersName: from,
                        message: message,
                        design: productId,
                        recipientName: to
                    },
                    cache: false,
                    success: function (html) {

                        $('#modalEgiftPreview').remove();

                        var closeText = $self.data('email-preview-close') !== undefined
                            ? $self.data('email-preview-close')
                            : 'Close';

                        const modalHtml = ModalTemplateHtml
                            .replaceAll('{{MODAL_CONTENT}}', html)
                            .replaceAll('{{MODAL_TITLE}}', $self.data('email-preview-title'))
                            .replaceAll('{{MODAL_CLOSE}}', closeText);

                        $('body').append(modalHtml);

                        $('#modalEgiftPreview').modal();

                        window.location.hash = 'modal';
                    },
                    complete: function () {
                        $self.parent().find('.preview-loading-spinner').hide();
                    }
                });
            }
        }

        function openInNewTab($self) {
            return $self.data('email-preview-new-tab') === true;
        }
    });

    $(document).on('click', '#modalEgiftPreview button[data-dismiss="modal"]', function () {
        $('button[data-email-preview-url]').focus();
    });

    $(window).on('hashchange', function () {
        if (window.location.hash != '#modal') {
            $('#modalEgiftPreview').modal('hide');
        }
    });
});

var ModalTemplateHtml =
    '<div id="modalEgiftPreview" class="modal egift-preview" tabindex="-1" role="dialog">' +
        '<div class="modal-dialog modal-lg" role="document">' +
            '<div class="modal-content">' +
                '<div class="modal-header">' +
                    '<h2 class="modal-title">{{MODAL_TITLE}}</h5>' +
                    '<button type="button" class="close" data-dismiss="modal" aria-label="{{MODAL_CLOSE}}">' +
                        '<span aria-hidden="true">&times;</span>' +
                        '<span class="close-text">{{MODAL_CLOSE}}</span>' +
                    '</button>' +
                '</div>' +
                '<div class="modal-body">' +
                    '<div class="email-content-wrapper">' +
                        '{{MODAL_CONTENT}}' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>' +
    '</div>';
